import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';
import { companyInfo, navLinks } from '../../data/mock';

const LOGO_URL = "/mldc-logo.jpg";

const Footer = () => {
  return (
    <footer className="bg-[#1a3a2f] text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center">
              <img 
                src={LOGO_URL} 
                alt="MLDC Agro" 
                className="h-36 w-auto"
              />
            </Link>
            <p className="text-white/80 leading-relaxed">
              Building a financially stronger future for farmers. We grow when farmers grow.
            </p>
            <div className="flex gap-4">
              <a href={companyInfo.socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#D3FF62] hover:text-[#004534] transition-all duration-200">
                <Facebook className="w-5 h-5" />
              </a>
              <a href={companyInfo.socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#D3FF62] hover:text-[#004534] transition-all duration-200">
                <Instagram className="w-5 h-5" />
              </a>
              <a href={companyInfo.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#D3FF62] hover:text-[#004534] transition-all duration-200">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href={companyInfo.socialLinks.youtube} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#D3FF62] hover:text-[#004534] transition-all duration-200">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-white/80 hover:text-[#D3FF62] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#D3FF62] flex-shrink-0 mt-1" />
                <a 
                  href={companyInfo.mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-[#D3FF62] transition-colors"
                >
                  {companyInfo.address.line1}, {companyInfo.address.line2}, {companyInfo.address.line3}, {companyInfo.address.line4}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#D3FF62] flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-white/80 hover:text-[#D3FF62] transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#D3FF62] flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-white/80 hover:text-[#D3FF62] transition-colors">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-5 h-5 text-[#D3FF62] flex-shrink-0" />
                <span className="text-white/80">
                  {companyInfo.hours.days}<br />
                  {companyInfo.hours.open} - {companyInfo.hours.close}
                </span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Stay Updated</h3>
            <p className="text-white/80 mb-4">Subscribe to our newsletter for the latest updates on agricultural insights.</p>
            <form className="space-y-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-3 rounded-full bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-[#D3FF62] transition-colors"
              />
              <button
                type="submit"
                className="w-full bg-[#D3FF62] text-[#004534] px-6 py-3 rounded-full font-semibold hover:bg-[#c4f050] transition-all duration-200"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} MLDC Agro. All Rights Reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-white/60 text-sm hover:text-[#D3FF62] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-white/60 text-sm hover:text-[#D3FF62] transition-colors">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
